export default {
  elBookModal: document.querySelector('#book-modal'),
  elModalContent: document.querySelector('.modal-book-container'),
  elBtnOpenModal: document.getElementById('open-modal-btn'),
  footerForm: document.querySelector('.footer-input-box'),
  footerInput: document.querySelector('.footer-input'),
  footerRemark: document.querySelector('.footer-remark'),
  footerBtn: document.querySelector('.footer-btn'),
  elModalCloseBtn: document.querySelector('.modal-close-btn'),  
};

